export default {
  /**
   * Filters by categories
   *
   * @param  {OBJ} resources  List of resources
   * @param  {OBJ} categories List of categories a resource must contain to be visible
   *
   * @return {OBJ} {visible, hidden} List of filtered resources
   */
  byCategory (resources, categories) {
    let filtered = {
      visible: {},
      hidden: {},
      hasActiveMarkers: false
    }

    for (const key in resources) {
      const resource = resources[key]
      let contains = Object.entries(resource.categories).some(([index, key]) => !categories[key])
      let filter = contains ? 'visible' : 'hidden'
      filtered[filter][key] = resource
      if (contains) filtered.hasActiveMarkers = true
    }

    return filtered
  },

  /**
   * Normalizes an intake config by removing empty answers or answers starting with 'null-'
   *
   * @param  {OBJ} config The intake answer set
   * @return {OBJ}        The noarmalized answer set
   */
  normalizeIntakeConfig (config) {
    let answers = {}
    for (const key in config) {
      if (config[key] && !config[key].includes('null-')) answers[key] = config[key]
    }
    return answers
  },

  /**
   * Filters by the intake checklist
   *
   * @param  {OBJ} resources List of resources
   * @param  {OBJ} checklist The intake checklist
   *
   * @return {OBJ} {visible, hidden} List of filtered resources
   */
  byChecklist (resources, checklist) {
    let filtered = {
      visible: {},
      hidden: {},
      hasActiveMarkers: false
    }
    let intake = this.normalizeIntakeConfig(checklist.intake)

    for (const key in resources) {
      const resource = resources[key]
      const requirements = this.normalizeIntakeConfig(resource.intakeConfig)

      // Automatically toss if there are no requirements
      if (!Object.keys(requirements).length) {
        filtered.hidden[key] = resource
        continue
      }

      // Check if at least some of the requirements are met
      let matched = Object.keys(requirements).some((question) => {
        filtered.hidden[key] = resource
        return intake[question] && intake[question] === requirements[question]
      })

      // Automatically remove if sex does not match
      if ((requirements.sex && intake.sex) && requirements.sex !== intake.sex) matched = false

      // Automatically remove if case work does not match
      if ((requirements.referral && intake.referral) && requirements.referral !== intake.referral) matched = false

      if (matched) {
        filtered.visible[key] = resource
        filtered.hasActiveMarkers = true
      } else {
        filtered.hidden[key] = resource
      }
    }

    return filtered
  }
}



// WEBPACK FOOTER //
// ./src/store/filters.js